import clsx from 'clsx';
import * as React from 'react';
import { ReactComponent as ArrowIcon } from '@lmt/unicorn-shared/app/icons/arrow-down-blue.svg';

import styles from './UniDetails.module.scss';
import i18next from 'i18next';

export interface DetailsProps {
  title?: string;
  className?: string;
  testId?: string;
  children?: React.ReactNode;
  defaultValue?: boolean;
}

export const UniDetails: React.FC<DetailsProps> = (props) => {
  const { title, className, children, defaultValue } = props;
  const [isShowDetails, setShowDetails] = React.useState<boolean>(
    defaultValue ?? false,
  );

  return (
    <>
      <div className={clsx(className, styles.container)}>
        <a
          className={styles.link}
          data-test-id={props.testId}
          onClick={() => setShowDetails(!isShowDetails)}
        >
          {!!title
            ? title
            : isShowDetails
            ? i18next.t('details.hide_details')
            : i18next.t('details.show_details')}
          <ArrowIcon className={styles.icon} data-up={isShowDetails} />
        </a>
      </div>
      {isShowDetails && children}
    </>
  );
};
